import { useParams, useNavigate } from "react-router-dom";
import useAppSelector from "../../../hooks/useAppSelector";
import useAuth from "../../../hooks/useAuth";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { useEffect } from "react";
import { fetchProperties, setProperty } from "../../../redux/slices/property";
import { getPropertyById } from "../Map";
import PropertyForm from ".././properties/PropertyForm";

export default function PropertyFormPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const dispatch = useAppDispatch();
  const { property, properties } = useAppSelector((state) => state.property);

  const isEditMode = Boolean(id);

  const associationId =
    currentUser?.activeAssociation?.id || currentUser?.associations?.[0]?.id;

  const propertyCheck = getPropertyById(id, properties);

  useEffect(() => {
    dispatch(fetchProperties(associationId));
  }, [associationId, dispatch]);

  useEffect(() => {
    if (propertyCheck && propertyCheck.id !== property?.id) {
      dispatch(setProperty(propertyCheck));
    }
  }, [propertyCheck, property, dispatch]);

  return (
    <PropertyForm
      initialData={isEditMode ? propertyCheck ?? property : undefined}
      isEditMode={isEditMode}
      onSuccess={() =>
        navigate("/properties", {
          state: {
            snackbar: {
              message: isEditMode
                ? "Kiinteistö päivitetty onnistuneesti"
                : "Kiinteistö luotu onnistuneesti",
              severity: "success",
            },
          },
        })
      }
    />
  );
}
